import styled from 'styled-components';

export const ArrowRightContainer = styled.div`
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #000;
  background-color: #fff;
  border-radius: 50%;
  overflow: hidden;

  svg {
    //  add !important to avoid the glitch
    width: 16px !important;

    &:first-child {
      margin-left: -32px;
      margin-right: 16px;
    }
  }
`;
